<template>

  <div class="month-sticky" :class="{ printview: props.printProject }">
    {{ visibleMonthLabel }}
  </div>
  <div class="time-axis" ref="axisRef">
    	<div v-if="!printProject" id="today-line-axis" class="today-line"> </div>
  </div>
</template>

<script setup>

  import { onMounted, ref, computed } from 'vue';
  import * as d3 from 'd3';
  import {isCloseToMultiple, nextDay, countBookingsForDay, getBookings, cleanx, germanDays, printHeaderHeight, dayMs, createAxisLine, isLastDayOfMonth, getWidthPerDay} from "./planner.js";
  import {useViewStore} from "@/stores/viewStore"

  const view = useViewStore();

  const visibleMonthLabel = ref("")

  const props = defineProps({ printProject: {type: [Object, null], default: null}, startDate: { type: Date, required: true },endDate:   { type: Date, required: true },  bookings: { type: Array, required: true}});

  const startDate = props.startDate;
  const endDate =  props.endDate;

  const germanLocale = d3.timeFormatLocale({
    dateTime: "%A, der %e. %B %Y, %X",
    date: "%d.%m.%Y",
    time: "%H:%M:%S",
    periods: ["AM", "PM"],
    days: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"],
    shortDays: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
    months: [
      "Januar", "Februar", "März", "April", "Mai", "Juni",
      "Juli", "August", "September", "Oktober", "November", "Dezember"
    ],
    shortMonths: [
      "Jan", "Feb", "Mär", "Apr", "Mai", "Jun",
      "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"
    ]
  });

  const pBookings = computed(() => getBookings(props.printProject, props.bookings))
  const dayCells = computed(() => {
	  const cells = [];
		

		let d = startDate;
    let lastDay = endDate;
		let i = 0;
				 
		while (d < lastDay) {
		  let count = countBookingsForDay(view, props.printProject, pBookings.value, d);
		  d = nextDay(d);
      console.log("d=" + d + " count=" + count)
		  cells.push(count === null ? 1000 : count);
		  i++;
		}		
    console.log("cells=" + JSON.stringify(cells))

	  return cells;
  });

  const axisRef = ref(null);
  const emit = defineEmits(['deselect'])
  let divAxisPrintHeaderHeight = props.printProject ? printHeaderHeight : 0;

  function showDateMarker(days, idx) {
    if (days.length - 1 === idx) {
       return true;
    }

    if (idx === 0) {
      return true;
    }

    return ((idx + 1) % 42) === 0;
  }

  function addWeeks(startDate, endDate, workWeeks, isprintView) {
    axisRef.value.appendChild(createAxisLine(view.zoomWidthPerDay,
      startDate, 
      endDate, 
      workWeeks, 
      function(d, i) {return d3.timeFormat("W%V")(d)}, // %V is the ISO week number (standard in Germany)
      (arr, i) => {
        // Simply return the next Monday in the array, or the endDate if last
        return arr[i + 1] || endDate;
      }, 
      false, 
      false, 
      isprintView,
      " weeks"
    ));
  }

  function renderTimeaxis() {
	  console.log("renderTimeaxis startDate=" + startDate)
	  console.log("renderTimeaxis endDate=" + endDate)

    const isprintView = props.printProject !== null
    const widthPerDay = getWidthPerDay(isprintView, view.zoomWidthPerDay)
    console.log("renderTimeaxis widthPerDay=" + widthPerDay)
    axisRef.value.innerHTML = '';
    const totalDays = (endDate - startDate) / dayMs;
    const x = d3.scaleUtc().domain([startDate, endDate]).range([0, totalDays * widthPerDay]);

    if (isprintView) {
      let divAxisPrintHeader = document.createElement("div");
      divAxisPrintHeader.classList.add("timeaxis-print-header")
      divAxisPrintHeader.style.height = divAxisPrintHeaderHeight + 'px'
      axisRef.value.appendChild(divAxisPrintHeader)  
    }

    // floor(startDate) ensures we get the 1st of the current month
    // ceil(endDate) ensures we get the 1st of the month AFTER the end
    const monthStart = d3.timeMonth.floor(startDate);
    const monthEnd = d3.timeMonth.ceil(endDate);

    const monthBoundaries = d3.timeMonth.range(monthStart, monthEnd);

    const weekStart = d3.timeMonday.floor(startDate);

    const weekEnd = d3.timeMonday.ceil(endDate);

    const workWeeks = d3.timeMonday.range(weekStart, weekEnd);
	  const days = d3.timeDay.range(startDate, endDate);

    axisRef.value.appendChild(createAxisLine(
      view.zoomWidthPerDay,
      startDate, 
      endDate, 
      isprintView ? workWeeks :  monthBoundaries, 
      function(d, i) {
        if (isprintView) {
          return "";
        }

        return germanLocale.format("%B %Y")(d)
      }, 
      (arr, i) => {
        let next = arr[i + 1] || endDate;
        return next;
      }, 
      false, 
      false, 
      isprintView,
      " monthline" + (isprintView ? " printview" : "")
    ));

    addWeeks(startDate, endDate, workWeeks, isprintView)

    //createAxisLine(startDate, endDate, data, format, getEnd = null, withWeekends = false, withHolidays = false, isprintView = false, extraClassLine = "", extraClassCell = "") {

   	axisRef.value.appendChild(createAxisLine(view.zoomWidthPerDay, startDate, endDate, days, (d, i) => {return germanDays[d.getDay()]}, null, true, !isprintView, isprintView));
    //console.log("days=" + JSON.stringify(days))
	  axisRef.value.appendChild(createAxisLine(view.zoomWidthPerDay, startDate, endDate, days, function(d, i) {
     let dd = d3.timeFormat("%d")(d);
     return dd + "."
    }, null, true, !isprintView, isprintView, " dateline"));
    if (isprintView) {
	    axisRef.value.appendChild(createAxisLine(view.zoomWidthPerDay, startDate, endDate, days, function(d, i) {
       return dayCells.value[i] || "";
      }, null, true, false, isprintView, " countline"));      
    }
	  axisRef.value.addEventListener("click", function(e) {
      emit('deselect')
    })

    days.forEach((day, idx) => {

      const leftPx = cleanx(x, day) + widthPerDay;
      const sunday = day.getDay() === 1;
	    const isLdm = isLastDayOfMonth(day);
		  let offset = isLdm ? 0 : (isprintView ? 0 : 1);

      let sdm = isprintView && showDateMarker(days, idx);
	    if (isLdm || day.getDay() === 0 || sdm) {

		    let div = document.createElement("div");
		    div.style.top = "0";
		    div.style.bottom = "0";
		    div.classList.add("highlight")
		    div.style.left = `${sdm ? 0 : leftPx + offset}px`;
		    if (isLdm) {
			    div.classList.add("last_day_month")
          div.style.top = divAxisPrintHeaderHeight + "px";
          if (isprintView) {
            div.style.top = divAxisPrintHeaderHeight + 13 + "px";
            div.style.height = 15 + "px";
            let endOfPage = isCloseToMultiple(idx + 1, 42, 3);
            if (endOfPage) {
              div.style.display = 'none'
            }
          }
		    } else if (day.getDay() === 0) {
			    div.classList.add("last_day_week")
		      div.style.left = `${leftPx + offset}px`;
          div.style.top = (divAxisPrintHeaderHeight + (isprintView ? 10 : 0) + 22) + "px";
          if (isprintView) {
			      div.classList.add("printview")
          }
		    }

        if (isLdm && day.getDay() === 0) {
            div.style.height = 35 + "px";
        }
		    axisRef.value.appendChild(div);
        if (sdm) {
		      div = document.createElement("div");
		      div.style.bottom = "0";
		      div.classList.add("highlight")
		      div.classList.add("sdm")
		      div.style.left = `${idx === 0 ? 0 : leftPx + offset}px`;
		      div.style.top = "20px";
          div.style.borderLeft = "2px solid black"
          div.style.height = 68 + "px";
          div.style.fontSize = "12px"
          div.style.paddingLeft = "2px"

          if (idx > 0) {
            let dateContent = document.createElement("div");
            dateContent.style.position = "absolute";
            dateContent.style.top = "0";
            dateContent.style.left = "0";
            div.appendChild(dateContent);
          }
		      axisRef.value.appendChild(div);
        }

	    } 
      if (isprintView) {

		    let div = document.createElement("div");
		    div.classList.add("highlight")
			  div.classList.add("daily")
			  div.classList.add("printview")

        if (isLdm && day.getDay() === 0) {
	        div.style.left = `${leftPx - widthPerDay + 2}px`;
	        div.style.width = `${widthPerDay}px`;
		      div.classList.add("weekend_month")
        } else if (idx === 0) {
	        div.style.left = `${0}px`;
	        div.style.width = `${widthPerDay}px`;
		      div.classList.add("first_day_timeaxis")
        } else {
	        div.style.left = `${leftPx + 1}px`;
        }
        div.style.top = (divAxisPrintHeaderHeight + (isprintView ? 26 : 0) + 22) + "px";
		    axisRef.value.appendChild(div);

        if (isLdm) {

		      div = document.createElement("div");
          div.classList.add("last_day_month_label")

          let endOfPage = isCloseToMultiple(idx + 1, 42, 3);

	        div.style.left = `${leftPx + 5}px`;
          div.style.top = (divAxisPrintHeaderHeight + 8) + "px";
		      div.style.bottom = "0";
          div.style.paddingLeft = (endOfPage ? 25 : 0) + "px"
          div.innerHTML = germanLocale.format("%B %Y")(nextDay(day))
		      axisRef.value.appendChild(div);          
        }

      }
    });

    console.log("props.printProject=" + JSON.stringify(props.printProject))
    if (!props.printProject) {
      let todayDiv = document.createElement("div");
		  todayDiv.classList.add("today-line")
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
		  todayDiv.style.left = `${cleanx(x, today)}px`;
      axisRef.value.appendChild(todayDiv);
    }

  }

onMounted(() => {renderTimeaxis();});

onMounted(() => {
  const container = document.querySelector(".main-scroll-area")

  const updateMonth = () => {
    const scrollLeft = container.scrollLeft

    const isprintView = props.printProject !== null
    const widthPerDay = getWidthPerDay(isprintView)

    // convert scroll → date
    const daysFromStart = scrollLeft / widthPerDay
    const currentDate = d3.timeDay.offset(startDate, Math.floor(daysFromStart))

    visibleMonthLabel.value = germanLocale.format("%B %Y")(currentDate)
  }

  container.addEventListener("scroll", updateMonth)
  updateMonth()
})

</script>
<style>
.time-axis {
  display: flex;
  flex-direction: column;
  background-color: white;
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 1px solid #ccc;
  width: max-content;

  /* Prevent the magnifying glass and text selection */
  -webkit-user-select: none; 
  user-select: none;

  /* Prevent the context menu/callout (Copy/Paste menu) */
  -webkit-touch-callout: none;

  /* Prevent system drag-and-drop of images or links */
  -webkit-user-drag: none;

}

.time-axis-line {
  display: flex;
  font-size: 12px;
  border-bottom: 1px solid #eee;
  height: 24px;
}

.time-axis-line.weeks.printview {
  border: none;
}

.time-axis-line.weeks.printview div.time-axis-cell{
  color: gray;
}

.time-axis-cell {
  flex: none;
  text-align: center;
  padding: 2px 0;
  border-left: 1px solid #eee;
  box-sizing: border-box;
}

.time-axis-cell.printview {
  font-size: 9px;
  font-weight: bold;
}


.monthline.printview {
  border: none !important;
}

.dateline.printview {
  border: none !important;
}

.countline {
  border-top: 1px solid black;
}

.countline div.time-axis-cell {
  display: block;
  padding-bottom: 3px;
  height: 100%;
}


.dateline div.time-axis-cell.printview{
  border: none !important;
}



.highlight {
  position: absolute;
  top: 0;
  bottom: 0;
}

.weekend {
  background-color: rgba(220, 220, 220, 0.4);
}

.holiday {
  background-color: rgba(220, 220, 220, 0.4);
}

.last_day_month {
	border-right: 2px solid gray !important;  
	z-index: 2	 !important;
	pointer-events: none;
}

.last_day_month_label {
	position: absolute;  
	z-index: 2	 !important;
	pointer-events: none;
  font-size: 11px;
}

.last_day_week {
	border-right: 0.25px solid gray !important;  
	z-index: 2	 !important;
	pointer-events: none;
}

.last_day_week.printview {
	border-right: 2px solid black !important;  
}

.first_day.printview {
	border-left: 2px solid black !important;  
}

.first_day_timeaxis.printview {
	border-left: 2px solid black !important;  
	border-right: 1px solid black !important;  
}

.weekend_month.printview {
	border-right: 2px solid black !important;  
}

.daily.printview {
	border-right: 1px solid black;  
}

.month-sticky {
  position: sticky;
  left: 0;
  top: 0;

  z-index: 50;

  background: white;
  padding: 4px 8px;

  font-size: 12px;

  width: fit-content;

  /* IMPORTANT */
  margin-bottom: -24px;

  pointer-events: none;
}

.month-sticky.printview {
  top: 45px;
}</style>